import script from "./ProvasEscola.vue?vue&type=script&setup=true&lang=js"
export * from "./ProvasEscola.vue?vue&type=script&setup=true&lang=js"

import "./ProvasEscola.vue?vue&type=style&index=0&id=6b6132f4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b6132f4"]])

export default __exports__